import { textNoWhiteSpacesRegex } from "@finway-group/shared/lib/utils/validators"
import { Rule } from "antd/lib/form"

import i18n from "Shared/locales/i18n"
import { doesContainForbiddenChars } from "Shared/utils/helper.utils"
import validateEmail from "Shared/validators/email.validator"

import { stringRules } from "Components/forms/rules/common/string.rules"
import { generalRules } from "Components/forms/rules/common/general.rules"

export const createUserRules = () => ({
    firstName: [
        generalRules.required,
        stringRules.noExcessWhitespace,
        {
            required: true,
            validator: (_rule, value: string) => {
                if (doesContainForbiddenChars(value) && value !== "") {
                    return Promise.reject(i18n.t("validation:name"))
                }

                return Promise.resolve()
            },
        },
        stringRules.allowedMultiLineCharsOnly,
    ] as Array<Rule>,
    lastName: [
        generalRules.required,
        stringRules.noExcessWhitespace,
        {
            required: true,
            validator: (_rule, value: string) => {
                if (doesContainForbiddenChars(value) && value !== "") {
                    return Promise.reject(i18n.t("validation:name"))
                }

                return Promise.resolve()
            },
        },
        stringRules.allowedMultiLineCharsOnly,
    ] as Array<Rule>,
    email: [
        {
            required: true,
            validator: (_rule, value: string) => {
                if (!value) {
                    return Promise.reject(i18n.t("validation:required"))
                }

                if (value !== value.trim()) {
                    return Promise.reject(new Error(i18n.t("validation:string_white_space_start_or_end")))
                }

                if (!textNoWhiteSpacesRegex.test(value)) {
                    return Promise.reject(new Error(i18n.t("validation:string_white_space")))
                }

                if (!validateEmail(value) && value) {
                    return Promise.reject(new Error(i18n.t("validation:email")))
                }

                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
})
